import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex flex-col items-center justify-end px-4 pb-20 pt-32 overflow-hidden" data-id="element-69">
      {/* Banner background image */}
      <img src="https://cdn.magicpatterns.com/uploads/hg4ngvbAuzt9x27zSQ9jTK/banner.png" alt="Axel Cut & Style Studio — premium barbershop tools" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-70" />

      {/* Dark gradient overlays for text legibility */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A] via-[#1A1A1A]/70 to-transparent" data-id="element-71"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#1A1A1A]/60 via-transparent to-[#1A1A1A]/40" data-id="element-72"></div>
      <div className="absolute inset-0 bg-black/30" data-id="element-73"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="mb-8" data-id="element-75">
          <img src="https://cdn.magicpatterns.com/uploads/oWPsSuhyfUnKiLy5tYqnnM/logo.png" alt="Axel Cut & Style Studio" className="w-36 h-36 md:w-48 md:h-48 object-contain mx-auto mix-blend-lighten drop-shadow-[0_0_15px_rgba(201,168,76,0.3)]" data-id="element-76" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} className="font-display italic text-4xl md:text-6xl lg:text-7xl leading-tight mb-6 gold-text px-4 drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]" data-id="element-77">
          Tired of Leaving the Salon Without the Look You Wanted?
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5,
        ease: 'easeOut'
      }} className="font-body text-cream text-lg md:text-xl max-w-2xl mx-auto mb-12 font-light leading-relaxed drop-shadow-[0_1px_6px_rgba(0,0,0,0.9)]" data-id="element-78">
          At Axel Cut & Style Studio we master the architecture of hair for men
          and women who refuse to look ordinary.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.7,
        ease: 'easeOut'
      }} data-id="element-79">
          <CTAButton className="text-sm md:text-base w-full sm:w-auto" data-id="element-80">
            Book Your Transformation Now
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}